const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-3',
            connection_id: 'connection-2'
        },
        chain_2: {
            chain_name: 'juno',
            client_id: '07-tendermint-501',
            connection_id: 'connection-505'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-417',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-1',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'kujira',
            client_id: '07-tendermint-160',
            connection_id: 'connection-123'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-119',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-5',
            connection_id: 'connection-4'
        },
        chain_2: {
            chain_name: 'noble',
            client_id: '07-tendermint-67',
            connection_id: 'connection-64'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-4',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-42',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-4',
            connection_id: 'connection-3'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-3029',
            connection_id: 'connection-2515'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-8690',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'furya',
            client_id: '07-tendermint-2',
            connection_id: 'connection-1'
        },
        chain_2: {
            chain_name: 'terra2',
            client_id: '07-tendermint-385',
            connection_id: 'connection-361'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-271',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
